<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <div style="text-align:center;">
        <iframe height="500" width="100%" :src="$store.getters.UrlTawkTo"></iframe>
      </div>

      <!-- <b-card-header header-tag="header" class="p-1" role="tab">Reclamos</b-card-header>
      <b-card-body>
        <tabs fill class="flex-column flex-md-row">
          <card shadow>
            <tab-pane>
              <span slot="title">
                <i class="fa fa-fw fa-sign-in-alt"></i>Mis reclamos
              </span>
              <div
                class="row"
                v-for="item in reclamos"
                @click="itemClicked(item)"
                v-bind:key="item.EntityID"
                v-bind:style="{ 'background-color': getColor(item.ExistResponse)}"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor:pointer; margin-right: 0; margin-left: 0; margin-top: 10px;border-radius: 10px;"
              >
                <div class="col-6">
                  Reclamo: {{item.FormattedClaim}}
                  <br />
                  Motivo: {{item.ReasonName}}
                  <br />
                </div>
                <div class="col-6">
                  Fecha {{item.FormattedDate}}
                  <br />
                </div>
                <div v-if="item.ShowDetails" class="col-12" style="margin-top: 10px;">
                  Comentario:
                  <br />
                  {{item.Comment}}
                </div>
                <div
                  v-if="item.ExistResponse && item.ShowDetails"
                  class="col-12"
                  style="margin-top: 10px;"
                >
                  Respuesta:
                  <br />
                  {{item.Response}}
                </div>
              </div>
            </tab-pane>

            <tab-pane>
              <span slot="title">
                <i class="fa fa-fw fa-sign-in-alt"></i>Nuevo reclamo
              </span>

              <div class="row form-group">
                <div class="col-md-12">
                  <label>Categoría</label>
                  <KitsCombo
                    v-model="CategoriaID"
                    v-bind:items="categorias"
                    propertyName="Name"
                    propertyID="EntityID"
                    :todos="true"
                    nullText="-- Seleccione categoría --"
                  ></KitsCombo>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-12">
                  <label>Motivo</label>
                  <KitsCombo
                    v-model="MotivoID"
                    v-bind:items="motivos"
                    propertyName="Name"
                    propertyID="EntityID"
                    :todos="true"
                    nullText="-- Seleccione motivo --"
                  ></KitsCombo>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-12">
                  <label>Comentario</label>
                  <base-input v-model="Comment"></base-input>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-12 text-center">
                  <save-button @click="guardar"></save-button>
                </div>
              </div>
            </tab-pane>

            <div class="container" style="text-align: right;">
              <a :href="$store.getters.UrlTawkTo" target="_blank">
                <img src="/img/logorojoChat.png" class="img-fluid" :style="WidthLogoChat" />
              </a>
            </div>
          </card>
        </tabs>
      </b-card-body>-->
    </b-card>
  </div>
</template>

<style>
.reclamo-respondido {
  background-color: #cdf5d5;
}
.reclamo-norespondido {
  background-color: #f9c9c9;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import KitsCombo from "@/components/KitsCombo";

export default {
  components: { KitsCombo },
  data() {
    return {
      reclamos: [],
      categorias: [],
      motivos: [],
      CategoriaID: null,
      MotivoID: null,
      Comment: "",
      WidthLogoChat: ""
    };
  },
  methods: {
    // Función para detectar si se abre desde un navegador o dispositivo móvil
    esDispositivoMovil() {
      // Obtener el User-Agent del navegador
      var userAgent = navigator.userAgent;

      // Verificar si el User-Agent contiene ciertas cadenas de texto que son comunes en dispositivos móviles
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    Initialize() {
      let context = this;
      if (context.esDispositivoMovil()) {
        context.WidthLogoChat = "width:18%";
      } else {
        context.WidthLogoChat = "width:7%";
      }
    },
    cargarReclamos() {
      let context = this;

      axiosHelpers.axiosPost("Claim/MyClaims", {}, this, function(data) {
        let ret = data.ResponseVM.Claims;

        for (var i = 0; i < data.ResponseVM.length; i++) {
          ret[i].ShowDetails = false;
        }

        context.reclamos = ret;
      });
    },
    itemClicked(item) {
      Vue.set(item, "ShowDetails", !item.ShowDetails);
    },
    getColor(exist) {
      if (exist) {
        return "#cdf5d5";
      } else {
        return "#f9c9c9";
      }
    },
    getCategorias() {
      let context = this;

      axiosHelpers.axiosPost("Claim/GetClaimsByCategory", {}, this, function(
        data
      ) {
        context.categorias = data.ResponseVM.Categories;
      });
    },
    guardar() {
      let context = this;

      if (
        this.MotivoID == null ||
        this.CategoriaID == null ||
        this.Comment == ""
      ) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Complete todos los campos",
          context
        );

        return;
      }
      axiosHelpers.axiosPost(
        "Claim/NewClaim",
        {
          ReasonID: this.MotivoID,
          CategoryID: this.CategoriaID,
          Comment: this.Comment
        },
        this,
        function(data) {
          if (data.ResponseVM.Result) {
            notificationHelpers.showSuccess(
              "Exito!",
              "Se envió su reclamo correctamente. Número de reclamo: " +
                data.ResponseVM.FormattedClaim,
              context
            );

            context.Comment = "";
            context.CategoriaID = null;
            context.MotivoID = null;

            context.cargarReclamos();
          }
        }
      );
    }
  },
  beforeMount: function() {
    // this.Initialize();
    // this.cargarReclamos();
    // this.getCategorias();
  },
  watch: {
    CategoriaID: function(val) {
      for (var i = 0; i < this.categorias.length; i++) {
        let cat = this.categorias[i];
        if (cat.EntityID == this.CategoriaID) {
          this.motivos = cat.Reasons;
          break;
        }
      }
      this.fullName = val + " " + this.lastName;
    }
  }
};
</script>